const products = [

    {
        id: 1,
        name: 'Fumigacion',
        productType: 'Servicio',
        price: 5400,
        target: '$5400',
        image: "/img/Foto.jpg",
        description: 'Control de cucarachas,hormigas, pulgas y mas',
        info: 'Cucarachas - Hormigas - Pulgas. El servicio comprende inspección, diagnóstico y  primer aplicación de tratamiento. Según diagnóstico se informará la necesidad de realizar más de un servicio. ',
        link: 'https://mpago.la/2LM7WHc'
    },
    {
        id: 2,
        name: 'Desratizacion',
        productType: 'Servicio',
        price: 4800,
        target: '$4800',
        image: "/img/ratas.jpg",
        description: 'Control y monitoreo de roedores',
        info: 'Control de roedores. El servicio incluye inspección, diagnóstico y recomendaciones de exclusión y tratamiento. Según nivel de infestación se recomendaran las cantidad de servicios necesarios.',
        link: 'https://mpago.la/2q4169f'

    },
    {
        id: 4,
        name: 'Sanitizacion',
        productType: 'Servicio',
        price: 6000,
        target: '$6000',
        image: "/img/sani.jpg",
        description: 'Sanitización de ambientes',
        info: 'Servicio de sanitización con amonio cuaternario de 5ta generación. Aplicación con nebulizador en frío ULV.',
        link: 'https://mpago.la/1sbhxQ1'
    }


]

export default products